import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormInput } from "../../../../Components";
import { hasValue } from "../../../../Helpers/validations/common";
import {
  getBookByISBNRequest,
  updateBookRequest,
} from "../../../../Backend/SchoolsRequests";
import { FormSelect } from "../../../../Components/Buttons/FormSelect/FormSelect";
import { bookNumberMask } from "../../../../Helpers/utils/utils";
import "./BookScanModal.scss";

export function BookScanModal({ onSubmit }) {
  const [t] = useTranslation();
  const { packageId } = useParams();
  const [alreadyScanned, setAlreadyScanned] = useState(false);
  const [ISBNScanned, setISBNScanned] = useState("");
  const [formState, setFormState] = useState(1);
  const [bookInfo, setBookInfo] = useState({
    id: "",
    barcode: 0,
    book: {
      id: "",
      isbn: "",
      bookNumber: 0,
      title: "",
      subject: null,
    },
    state: 0,
    reportType: null,
    schoolScan: false,
    schoolSuitable: false,
  });

  const [suitableList] = useState([
    { id: 1, name: t("Suitable") },
    { id: 2, name: t("NotSuitable") },
  ]);

  const [suitableSelected, setSuitableSelected] = useState(1);

  const inputId = "barcodeInputId";

  const info = [
    { key: t("BookNumber"), value: bookNumberMask(bookInfo.book.bookNumber) },
    { key: t("Title"), value: bookInfo.book.title },
    { key: t("ISBN"), value: bookInfo.book.isbn },
  ];

  useEffect(() => {
    if (hasValue(ISBNScanned) && ISBNScanned.length === 13) {
      filterBookByBarcode();
    }
  }, [ISBNScanned]);

  useEffect(() => {
    if (hasValue(bookInfo.id)) {
      updateBook();
    }
  }, [bookInfo, suitableSelected]);

  useEffect(() => {
    const element = document.getElementById(inputId);
    if (element) {
      element.focus();
      element.onfocus = function () {
        this.select();
      };
    }
  }, []);

  const filterBookByBarcode = async () => {
    const resp = await getBookByISBNRequest(packageId, parseInt(ISBNScanned));

    if (resp.success) {
      const found = resp.data.list[0];
      if (found && hasValue(found.id)) {
        setBookInfo(found);
        setSuitableSelected(
          found.schoolScan === false ? 1 : found.schoolSuitable ? 1 : 2
        );
        setFormState(2);
      } else {
        setFormState(3);
      }
    }
  };

  const updateBook = async () => {
    const body = [
      {
        id: bookInfo.id,
        schoolScan: true,
        schoolSuitable:
          bookInfo.schoolScan === false
            ? true
            : suitableSelected.toString() === "1",
      },
    ];
    if (bookInfo.schoolScan === true) {
      setAlreadyScanned(true);
    } else {
      setAlreadyScanned(false);
    }
    const resp = await updateBookRequest(body);
    if (resp.success) {
      const element = document.getElementById(inputId);
      if (element) {
        element.select();
      }
      onSubmit(bookInfo.id);
    }
  };

  const renderBody = () => {
    switch (formState) {
      case 1:
        return "";
      case 2:
        if (hasValue(ISBNScanned)) {
          return (
            <div className="book-info-wrapper">
              <div className="subtitle">{t("BookInformation")}</div>
              {info.map((x) => (
                <div className="info-row" key={"info-" + x.key}>
                  <span className="key">{x.key}:</span>
                  <span className="value">{x.value}</span>
                </div>
              ))}
              <div className="select-wrapper">
                <span className="label">{t("BookCondition")}</span>
                <FormSelect
                  type="text"
                  options={suitableList}
                  value={suitableSelected}
                  change={(x) => setSuitableSelected(x)}
                />
              </div>
            </div>
          );
        }
      case 3:
        return (
          <div className="book-info-wrapper">
            <div className="subtitle">{t("BookInformation")}</div>
            <div className="error-wrapper">
              <span className="message">{t("BookNotFound")}</span>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="book-scan-modal">
      <div className="title">{t("Book")}</div>
      <div className="book-scan-content">
        <div className="subtitle">{t("BookScanModal")}</div>
        <div className="text">{t("BookScanModalText")}</div>
        <div className="info-wrapper">
          <div className="input-wrapper">
            <FormInput
              inputId={inputId}
              placeholder=""
              type="text"
              value={ISBNScanned}
              change={(x) => {
                setISBNScanned(x.replace(/\D/g, ""));
              }}
              otherProperties={{
                maxLength: 13,
                minLength: 13,
              }}
            />
          </div>
          {renderBody()}
        </div>
        {alreadyScanned && <div className="already-scanned-book">{t("AlreadyScannedBook")}</div>}
      </div>
    </div>
  );
}
